import { render } from "./PMaintenance.vue?vue&type=template&id=10135eb8&scoped=true"
import script from "./PMaintenance.vue?vue&type=script&lang=js"
export * from "./PMaintenance.vue?vue&type=script&lang=js"

import "./PMaintenance.vue?vue&type=style&index=0&id=10135eb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10135eb8"]])

export default __exports__